import React from "react";
import { Sparkles, Flame, Disc3 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionLabel, MaskedHeading, Reveal } from "@/components/site/Motion";

const CLUB_IMG =
  "https://images.pexels.com/photos/2114365/pexels-photo-2114365.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=900";

const ICONS = [Sparkles, Flame, Disc3];

export const Performances = () => {
  const { t } = useLang();
  return (
    <section id="perf" className="py-24 md:py-36 px-6 md:px-12 max-w-[1600px] mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Image */}
        <Reveal className="lg:col-span-5">
          <div className="relative overflow-hidden h-[380px] md:h-[560px]">
            <img src={CLUB_IMG} alt="VIP1 live stage" className="w-full h-full object-cover" />
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
            <div className="absolute inset-0 bg-gradient-to-t from-obsidian/80 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6">
              <p className="font-display text-xs tracking-[0.3em] uppercase text-brand mb-1">Night Club</p>
              <p className="font-heading text-3xl md:text-4xl text-white">Live • Show • Energy</p>
            </div>
          </div>
        </Reveal>

        {/* Content */}
        <div className="lg:col-span-7 lg:pl-6">
          <SectionLabel>{t.perf.overline}</SectionLabel>
          <h2 className="font-heading text-4xl md:text-6xl text-white tracking-tight leading-[1.02]">
            <MaskedHeading text={t.perf.title} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-5 mb-10 font-body text-white/60 leading-relaxed max-w-xl">{t.perf.desc}</p>
          </Reveal>

          <div className="space-y-px">
            {t.perf.items.map((item, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <Reveal key={i} delay={i * 0.1}>
                  <div className="group flex gap-6 py-6 border-t border-white/10 hover:border-brand/40 transition-colors">
                    <span className="text-brand mt-1 shrink-0"><Icon size={26} /></span>
                    <div>
                      <h3 className="font-display text-xl md:text-2xl text-white group-hover:translate-x-1 transition-transform">
                        {item.title}
                      </h3>
                      <p className="mt-2 font-body text-white/55 leading-relaxed max-w-lg">{item.text}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
